<template>
  <div>
    <h1> v{{ version }} </h1>
      <div class="ml-3" v-for="note in releaseNotes"> {{ note.split(`&amp;nbsp;`).join('&nbsp;') }} <br> </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      version: process ? process.env.VUE_APP_VERSION : 'X.XX',
    }
  },
  computed: {
    releaseNotes () {
      const lines = []
      if (!process) return lines
      const tmp = process.env.VUE_APP_RELEASE_NOTES.split('<br><br>')
      tmp.forEach(i => lines.push(...i.split('<br>')))
      return lines
    }
  }
}
</script>

<style>

</style>